const pageKey = "pageSize";

const websiteMapper = {
  "SZ SF":
    "https://www.sf-express.com/cn/en/dynamic_function/waybill/#send/page=1",
  DHL: "https://www.dhl.com/en.html",
  Roadbull: "https://roadbull.com",
  "Alpha and ThaiPost": "https://www.alphafast.com/track?lang=en",
  NinjaVan: "https://www.ninjavan.co/en-ph",
  "CJ Logistics": "https://www.cjlogistics.com/en/main",
  Citylink: "http://www.citylinkexpress.com/",
  "J&T": "http://jet.co.id/",
  "247 express": "https://www.247post.vn/",
  Maple: "https://www.25431010.tw/tracking",
  "TW SF": "https://www.sf-express.com/tw/tc/dynamic_function/waybill/",
  "Overseas DHL": "www.dhl.com",
  "Chunghwa Post":
    "https://www.post.gov.tw/post/internet/SearchZone/default.jsp",
  "SG PickUpp": "https://sg.pickupp.io/en/tracking",
  LBC: "https://www.lbcexpress.com/",
  "Australia Post": "https://auspost.com.au/mypost/track/#/search",
  "HK SF Express": "https://htm.sf-express.com/hk/tc/dynamic_function/waybill/",
  "TH Post": "https://track.thailandpost.co.th/?trackNumber=",
  USPS: "https://tools.usps.com/go/TrackConfirmAction_input",
  FedEx: "https://www.fedex.com/en-us/tracking.html",
  JNE: "https://www.jne.co.id/en/home",
  "Ninjavan-SG": "https://www.ninjavan.co/en-sg/tracking",
  EMS: "https://www.ems.com.cn/queryList",
  "GoGo Xpress": "https://app.gogoxpress.com/track/",
  "EPG Track": "https://epgtrack.com/"
};

export { pageKey, websiteMapper };
